export const AOS_ANIMATION = {
  FADE_UP: {
    DURATION: "800",
    TYPE: "fade-up",
  },
  FADE_LEFT: {
    DURATION: "800",
    TYPE: "fade-left",
  },
  FADE_RIGHT: {
    DURATION: "800",
    TYPE: "fade-right",
  },
  FLIP_LEFT: {
    DURATION: "800",
    TYPE: "flip-left",
  },
};
